export const getSessionAuthorization = (): string => {
  const stored = localStorage.getItem("s") ?? sessionStorage.getItem("s");
  if (!stored) return "";

  try {
    const parsed: unknown = JSON.parse(stored);
    return typeof parsed === "string" ? parsed : "";
  } catch {
    return stored;
  }
};

export const getCurrentCompanyId = (): string | null =>
  localStorage.getItem("companyId");

export const uploadHeaders = (): Record<string, string> => {
  const authorization = getSessionAuthorization();
  const companyId = getCurrentCompanyId();

  return {
    ...(authorization ? { Authorization: authorization } : {}),
    ...(companyId ? { "X-Company-Id": companyId } : {}),
  };
};
